import {
  createPauseScreenModel,
  type PauseScreenProps,
} from './PauseScreenModelScreen';
import { PauseScreenController } from './PauseScreenController';
import { PauseScreenView } from './PauseScreenView';

export type { PauseScreenProps } from './PauseScreenModelScreen';

export function PauseScreen(props: PauseScreenProps) {
  const model = createPauseScreenModel(props);
  const controller = new PauseScreenController(model);

  return <PauseScreenView model={model} controller={controller} />;
}
